export const API_SUCCESS = 'unifi.API_REQUEST_SUCCESS';
export const API_FAIL = 'unifi.API_REQUEST_FAIL';
export const API_PENDING = 'unifi.API_REQUEST_PENDING';
export const API_SUBSCRIBE_UPDATE = 'unifi.API_SUBSCRIBE_UPDATE';



// WEBPACK FOOTER //
// ./src/redux/api/constants.js